<template>
  <div class="container">
    <div class="content-box">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto">
              <h3 class>Parceiros</h3>
            </div>
            <div class="col-auto">
              <b-button :to="{name: 'ParceiroForm'}">Novo</b-button>
            </div>
          </div>
        </div>

        <div>
          <div class="row">
            <div class="col mb-2"></div>
          </div>

          <div class="row">
            <div class="col">
              <div class="element-box">
                <div class="mb-4">
                  <b-pagination
                      v-model="currentPage"
                      :total-rows="totalCount"
                      :per-page="perPage"
                      :current-page="currentPage"
                      align="fill"
                      size="sm"
                      class="my-0"
                  ></b-pagination>
                </div>

                <b-table
                    id="listParceiro"
                    name="listParceiro"
                    ref="listParceiro"
                    striped
                    hover
                    bordered
                    :current-page="currentPage"
                    :per-page="perPage"
                    :items="getParceiros"
                    :fields="fieldList"
                >
                  <template slot="[acoes]" slot-scope="row">
                    <b-button
                        variant="outline-primary"
                        size="sm"
                        :title="`Ofertas do Plano ${row.item.nome}`"
                        @click="goOfertas(row.item)"
                    >
                      <i class="fa fa-percent"></i>
                    </b-button>
                    <b-button
                        variant="outline-primary"
                        size="sm"
                        title="Excluir"
                        @click="excluir(row.item)"
                    >
                      <i class="fa fa-trash"></i>
                    </b-button>
                    <b-button
                        variant="outline-primary"
                        size="sm"
                        title="Editar"
                        @click="editar(row.item)"
                    >
                      <i class="fa fa-edit"></i>
                    </b-button>
                    <b-button v-if="!row.item.status || row.item.status === '0'"
                              variant="outline-success" size="sm" title="Ativar"
                       @click="ativar(row.item)">
                      <i class="fa fa-check"></i>
                    </b-button>
                    <b-button v-else
                              variant="outline-danger" size="sm" title="Inativar"
                              @click="inativar(row.item)">
                      <i class="fa fa-times"></i>
                    </b-button>

                  </template>
                </b-table>


              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from "moment";

export default {
  name: "ParceiroList",
  computed: {
    empresa() {
      return this.$store.getters.empresa;
    }
  },
  watch: {
    empresa() {
      this.$root.$emit('bv::refresh::table', 'listParceiro')
    }
  },
  data: () => ({
    currentPage: 1,
    perPage: 10,
    totalCount: 0,
    fieldList: [
      {
        key: 'nome',
        label: 'Nome'
      },
      {
        key: 'categorias',
        label: 'Categorias',
        formatter: value => {
          return value.map(categoria => categoria.name).toString().replace(/["'[ \]]/g,'')
        }
      },
      {
        key: "createdAt",
        label: "Data cadastro",
        formatter: value => {
          return moment(value).format("DD/MM/YYYY");
        }
      },
      {
        key: 'acoes',
        label: ''
      }
    ]
  }),
  methods: {
    getParceiros(ctx) {
        this.currentPage = ctx.currentPage;
        let promise = axios.get('/api/parceiro/filter', {
          params: {
            limit: this.perPage,
            page: ctx.currentPage,
            juridica: this.empresa._id
          }
        });

        return promise.then(response => {
          this.totalCount = response.data.totalCount;
          return response.data.data || [];
        })
    },
    goOfertas(parceiro) {
      this.$router.push({name: 'OfertaList', query: {parceiro: parceiro._id}});
    },
    async excluir(parceiro) {
      const value = await this.$bvModal.msgBoxConfirm('Deseja realmente remover o Parceiro? Ao confirmar todos os dados do parceiro será perdido. Deseja Continuar?', {
        title: 'Excluir Parceiro',
        centered: true,
        okTitle: 'Sim',
        cancelTitle: 'Não',
      });

      if (value) {
        try {
          this.$store.dispatch('setLoading', true);

          await axios.delete(`/api/parceiro/${parceiro._id}/parceiros`);

          this.$root.$emit('bv::refresh::table', 'listParceiro');
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('error', e);
        } finally {
          this.$store.dispatch('setLoading', false);
        }
      }
    },
    editar(parceiro) {
      this.$router.push({name: 'ParceiroForm', query: {id: parceiro._id}});
    },
    async ativar(parceiro) {
      try {
        this.$store.dispatch('setLoading', true);

        const parceiroFind = await axios.get(`/api/parceiro/${parceiro._id}`).then(response => response.data);
        parceiroFind.status = 1;

        const formData = new FormData();
        formData.append('id', parceiroFind._id);
        formData.append('payload', JSON.stringify(parceiroFind));

        await axios.post('/api/parceiro/insert', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        this.$root.$emit('bv::refresh::table', 'listParceiro');
        this.$store.dispatch('setLoading', false);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('error', e);
      } finally {
        this.$store.dispatch('setLoading', false);
      }
    },
    async inativar(parceiro) {
      try {
        this.$store.dispatch('setLoading', true);

        const parceiroFind = await axios.get(`/api/parceiro/${parceiro._id}`).then(response => response.data);
        parceiroFind.status = 0;

        const formData = new FormData();
        formData.append('id', parceiroFind._id);
        formData.append('payload', JSON.stringify(parceiroFind));

        await axios.post('/api/parceiro/insert', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        this.$root.$emit('bv::refresh::table', 'listParceiro');
        this.$store.dispatch('setLoading', true);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('error', e);
      } finally {
        this.$store.dispatch('setLoading', false);
      }
    }
  }
}
</script>

<style scoped>

</style>
